import { render, staticRenderFns } from "./ContactListCard.vue?vue&type=template&id=3161bc42&"
import script from "./ContactListCard.vue?vue&type=script&lang=js&"
export * from "./ContactListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports